__turbopack_context__.v({
  "component": "style-module-scss-module__0m4OFa__component",
  "header": "style-module-scss-module__0m4OFa__header",
  "home-block": "style-module-scss-module__0m4OFa__home-block",
  "inline-title": "style-module-scss-module__0m4OFa__inline-title",
  "left": "style-module-scss-module__0m4OFa__left",
  "location": "style-module-scss-module__0m4OFa__location",
  "location-selector-wrap": "style-module-scss-module__0m4OFa__location-selector-wrap",
  "mobile-view-map": "style-module-scss-module__0m4OFa__mobile-view-map",
  "properties": "style-module-scss-module__0m4OFa__properties",
});
